import { useMutation, useQuery } from '@tanstack/react-query';
import { bankCardApiService } from '../services/bankCardApi';
import type { BankCard, BankCardAuthForm } from '../types/bankCard';
import { useMemo } from 'react';

export const BankCardQueryKeys = {
  bankCards: 'bankCards',
};

interface UseBankCardReturn {
  bankCards: BankCard[];
  defaultBankCard: BankCard | undefined;
  isLoading: boolean;
  initBankCardAuth: () => Promise<BankCardAuthForm>;
}

export const useBankCard = (
  fetchBankCards: boolean = false
): UseBankCardReturn => {
  const { data: bankCards, isLoading } = useQuery({
    queryKey: [BankCardQueryKeys.bankCards],
    queryFn: () => bankCardApiService.getUserBankCards(),
    enabled: fetchBankCards,
  });

  const defaultBankCard = useMemo(() => {
    return bankCards?.find((bankCard) => bankCard.isActive);
  }, [bankCards]);

  const initBankCardAuth = useMutation({
    mutationFn: () => bankCardApiService.initBankCardAuth(),
  });

  return {
    bankCards: bankCards ?? [],
    defaultBankCard,
    isLoading,
    initBankCardAuth: initBankCardAuth.mutateAsync,
  };
};
